import axios from 'axios'
import router from '../router'

// 防止重复重定向的标志
let isRedirecting = false

const service = axios.create({
  baseURL: '/chat-api',
  timeout: 30000 // 默认30秒，邮箱验证码发送可能需要更长时间
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    const url = response.config?.url || ''
    
    // 排除登录、注册等不需要token的接口，避免误判
    const isAuthEndpoint = url.includes('/auth/login') || 
                           url.includes('/auth/register') || 
                           url.includes('/auth/emailLogin') || 
                           url.includes('/auth/phoneLogin') ||
                           url.includes('/auth/sendEmailCode') ||
                           url.includes('/auth/sendSmsCode') ||
                           url.includes('/auth/checkEmail') ||
                           url.includes('/auth/checkPhone') ||
                           url.includes('/auth/forgotPassword') ||
                           url.includes('/auth/generateCaptcha')
    
    if (res.code !== 0) {
      // 只有在非登录相关接口返回401时，才重定向到登录页
      if (res.code === 401 && !isAuthEndpoint && !isRedirecting) {
        isRedirecting = true
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        // 使用路由跳转而不是直接修改location，避免页面刷新
        router.push('/login').catch(err => {
          // 如果路由跳转失败（比如不在Vue组件中），再使用location
          if (err.name !== 'NavigationDuplicated') {
            window.location.href = '/login'
          }
        })
        // 3秒后重置标志，允许再次重定向（防止永久锁定）
        setTimeout(() => {
          isRedirecting = false
        }, 3000)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res
  },
  error => {
    // 处理401未授权错误（token过期或登录失效）
    if (error.response) {
      const status = error.response.status
      const code = error.response.data?.code
      const url = error.config?.url || ''
      
      // 排除登录、注册等不需要token的接口，避免误判
      const isAuthEndpoint = url.includes('/auth/login') || 
                             url.includes('/auth/register') || 
                             url.includes('/auth/emailLogin') || 
                             url.includes('/auth/phoneLogin') ||
                             url.includes('/auth/sendEmailCode') ||
                             url.includes('/auth/sendSmsCode') ||
                             url.includes('/auth/checkEmail') ||
                             url.includes('/auth/checkPhone') ||
                             url.includes('/auth/forgotPassword') ||
                             url.includes('/auth/generateCaptcha')
      
      // 检查HTTP状态码401或响应体中的code为401
      // 但排除登录相关接口，因为这些接口可能返回401表示登录失败，不应该重定向
      if ((status === 401 || code === 401) && !isAuthEndpoint && !isRedirecting) {
        console.log('Token过期或登录失效，重定向到登录页')
        isRedirecting = true
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        // 使用路由跳转而不是直接修改location，避免页面刷新
        router.push('/login').catch(err => {
          // 如果路由跳转失败（比如不在Vue组件中），再使用location
          if (err.name !== 'NavigationDuplicated') {
            window.location.href = '/login'
          }
        })
        // 3秒后重置标志，允许再次重定向（防止永久锁定）
        setTimeout(() => {
          isRedirecting = false
        }, 3000)
        return Promise.reject(new Error('登录已失效，请重新登录'))
      }
    }
    
    // 处理超时错误，特别是邮箱验证码发送
    if (error.code === 'ECONNABORTED' || error.message && error.message.includes('timeout')) {
      const url = error.config?.url || ''
      if (url.includes('sendEmailCode')) {
        return Promise.reject(new Error('邮箱验证码发送超时，请稍后重试。验证码可能仍在发送中，请稍等片刻后查看邮箱。'))
      }
      return Promise.reject(new Error('请求超时，请稍后重试'))
    }
    return Promise.reject(error)
  }
)

export default service

